import React from 'react';
import { ScrollArea } from '@/components/ui/scroll-area';
import { TraceTreeItem } from './TraceTreeItem';
import type { TraceItem } from '@/types/trace';

interface TreeViewProps {
  items: TraceItem[];
}

export function TreeView({ items }: TreeViewProps) {
  if (items.length === 0) {
    return (
      <div className="flex items-center justify-center h-32 text-muted-foreground text-sm">
        No trace items found
      </div>
    );
  }

  return (
    <ScrollArea className="flex-1">
      <div className="py-2">
        {items.map((item) => (
          <TraceTreeItem key={item.id} item={item} />
        ))}
      </div>
    </ScrollArea>
  );
}

export default TreeView;
